export default ({ request }) => ({
    sysMerchantFunctionListApi(data = {}) {
        return request({
            url: '/sys/merchantFunction/list',
            method: 'post',
            data,
        })
    },
    sysMerchantFunctionTreeApi(data = {}) {
        return request({
            url: '/sys/merchantFunction/tree',
            method: 'post',
            data,
        })
    },
    sysMerchantFunctionDetailApi(data = {}) {
        return request({
            url: '/sys/merchantFunction/detail',
            method: 'post',
            data,
        })
    },
    sysMerchantFunctionChangeApi(data = {}) {
        return request({
            url: '/sys/merchantFunction/change/btnid',
            method: 'post',
            data,
        })
    },
    sysMerchantFunctionSaveApi(data = {}) {
        return request({
            url: '/sys/merchantFunction/save',
            method: 'post',
            data,
        })
    },
    sysMerchantFunctionDelApi(data = {}) {
        return request({
            url: '/sys/merchantFunction/del',
            method: 'post',
            data,
        })
    },
})